export enum ReactAppMode {
    'VCAP' = 'VCAP',
    'LOCAL' = 'LOCAL',
    'VOA' = 'VOA'
};
